import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle, X } from 'lucide-react';
import api from '../services/api';

// Pop-up de migração de infraestrutura: aparece quando o tenant tem alguma
// instância WhatsApp registrada que não está conectada (estado != 'open').
// Some sozinho assim que o cliente reconecta — não precisa de limpeza manual.
export default function MigrationReconnectModal() {
  const [precisaReconectar, setPrecisaReconectar] = useState(false);
  const [fechado, setFechado] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    let cancelado = false;
    (async () => {
      try {
        const { data } = await api.get('/whatsapp/instancias');
        const lista = Array.isArray(data) ? data : [];
        if (lista.length === 0) return;

        const estados = await Promise.all(lista.map(async (inst) => {
          const nome = inst?.instance?.instanceName || inst?.instanceName || inst?.name || null;
          if (!nome) return 'unknown';
          if (inst._naoEncontrada) return 'nao_encontrada';
          try {
            const { data: s } = await api.get(`/whatsapp/instancias/${nome}/status`);
            return s?.instance?.state || s?.state || 'unknown';
          } catch {
            return 'unknown';
          }
        }));

        if (!cancelado && estados.some(e => e !== 'open')) {
          setPrecisaReconectar(true);
        }
      } catch {
        /* silencioso — sem instâncias ou erro de rede */
      }
    })();
    return () => { cancelado = true; };
  }, []);

  if (!precisaReconectar || fechado) return null;

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: 'rgba(15,17,32,0.7)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 16,
    }}>
      <div style={{
        background: '#1c1f2a', color: '#fff', borderRadius: 14,
        maxWidth: 440, width: '100%', padding: '28px 26px',
        boxShadow: '0 24px 60px rgba(0,0,0,0.45)', position: 'relative',
      }}>
        <button
          onClick={() => setFechado(true)}
          aria-label="Fechar"
          style={{
            position: 'absolute', top: 14, right: 14, background: 'none',
            border: 'none', color: '#9ca3af', cursor: 'pointer', padding: 4,
          }}
        >
          <X size={18} />
        </button>

        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          width: 48, height: 48, borderRadius: '50%',
          background: 'rgba(252,211,77,0.15)', marginBottom: 16,
        }}>
          <AlertTriangle size={24} color="#fcd34d" />
        </div>

        <h2 style={{ fontSize: 19, fontWeight: 700, margin: '0 0 10px' }}>
          Reconecte seu WhatsApp
        </h2>

        <p style={{ fontSize: 14, lineHeight: 1.5, color: '#cbd5e1', margin: '0 0 8px' }}>
          Atualizamos nossa infraestrutura para deixar a plataforma mais rápida e
          estável. Para manter sua automação funcionando, você precisa reconectar
          o WhatsApp escaneando o QR code novamente.
        </p>
        <p style={{ fontSize: 13, lineHeight: 1.5, color: '#94a3b8', margin: '0 0 20px' }}>
          Suas campanhas, contatos e configurações <strong>não foram afetados</strong> —
          continuam salvos. Leva menos de 1 minuto.
        </p>

        <button
          onClick={() => { setFechado(true); navigate('/whatsapp'); }}
          style={{
            width: '100%', background: '#22c55e', color: '#fff',
            border: 'none', borderRadius: 8, padding: '11px 16px',
            fontSize: 14, fontWeight: 700, cursor: 'pointer',
          }}
        >
          Reconectar agora
        </button>
      </div>
    </div>
  );
}
